import React from "react";

const CommonLoader = () => {
    return(<div className="loaderwrapper">
        <div className="loader"></div>
        <h4>Please wait file is uploading !</h4>
    </div>)
};

export default CommonLoader;